import { connect } from 'react-redux';
import { unhideDeviation, blockDeviationAuthor, unblockDeviationAuthor, } from '../../../Moderation/redux/actions';
import { getHighestPriorityBlockReasonForDeviation } from '../../../Moderation/redux/selectors';
import { getIsLoggedIn, toggleMature } from '../../../publicSession';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        isLoggedIn: getIsLoggedIn(state),
        blockReason: getHighestPriorityBlockReasonForDeviation(state, deviation),
    });
};
var mapDispatchToProps = {
    unhideDeviation: unhideDeviation,
    blockDeviant: blockDeviationAuthor,
    unblockDeviant: unblockDeviationAuthor,
    disableMatureFilter: function () { return toggleMature(false); },
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Hidden.container.js.map